import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { DefaultLayout } from './DefaultLayout';

export function DefaultRouteCheckMobile({ component: Component, ...rest }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      setIsMobile(mobileRegex.test(navigator.userAgent));
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return (
    <Route
      {...rest}
      render={routeProps => (
        isMobile ? (
          <Component {...routeProps} />
        ) : (
          <DefaultLayout>
            <Component {...routeProps} />
          </DefaultLayout>
        )
      )}
    />
  );
}